import { SimpleGrid, Text, Box } from '@chakra-ui/react';
import ProfileCard from '../districtProfile/ProfileCard'
import { ShareBars } from './ShareBars'
import { StatTile } from '../shared/viz'
import type { ListOverview } from '../../types/contactList'
import { useIsUnionTier } from '../../hooks/useIsUnionTier'

export function UnionPanel({ overview }: { overview: ListOverview }) {
  if (!useIsUnionTier()) return null
  const u = overview.union
  return (
    <ProfileCard eyebrow="Union" title="Labor footprint" source="Live committee employment data">
      <Text fontSize="3xl" fontWeight="bold" color="accent" mt={2}>{u.memberPct}%</Text>
      <Text fontSize="sm" color="gray.500" mb={3}>of contacts have a union member</Text>
      <SimpleGrid columns={3} gap={4} mb={4}>
        <StatTile label="Members" value={u.memberCount.toLocaleString()} />
        <StatTile label="Stewards" value={u.stewardCount.toLocaleString()} />
        <StatTile label="Unions" value={u.unionCount.toLocaleString()} />
      </SimpleGrid>
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2}>Top unions represented</Text>
        <ShareBars rows={u.topUnions} color="green" />
      </Box>
    </ProfileCard>
  );
}
